import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrenyService {

  constructor(
    private decimalPipe: DecimalPipe
  ) { }

  public replaceSpanishFormat(value: string): number {
    let replacedText = value.replace(/[^0-9,]*/g, '');
    replacedText = replacedText.replace(',', '.');
    return Number(replacedText);
  }

  public setSpanishCurreny(value: number): string {
    const textValue = this.decimalPipe.transform(value, '1.2-2');
    const textSplit = textValue.split('.');
    return `${textSplit[0].replace(',', '.')},${textSplit[1]}`;
  }

}
